import type { Theme } from '@mui/material/styles';
import type { SemanticStatusPalette, SemanticStatusVariant } from '@bloomays-lib/ui.shared';
import type { DataGridV2Tone } from '@bloomays-lib/ui.shared/datagrid';
import type { MissionPurchaseOrderIndicator } from './missionPurchaseOrderStatus';
import type { MissingUrgency, PurchaseOrderDisplayStatus } from './purchaseOrderDashboard';

export const getSemanticStatusPalette = (theme: Theme, variant: SemanticStatusVariant): SemanticStatusPalette =>
  theme.palette.semanticStatus[variant];

export const PURCHASE_ORDER_DISPLAY_STATUS_VARIANT: Record<PurchaseOrderDisplayStatus, SemanticStatusVariant> = {
  received: 'success',
  partial: 'warning',
  waiting: 'info',
  expired: 'error',
  soldout: 'neutral',
};

export const PURCHASE_ORDER_DISPLAY_STATUS_TONE: Record<PurchaseOrderDisplayStatus, DataGridV2Tone> = {
  received: 'success',
  partial: 'warning',
  waiting: 'info',
  expired: 'danger',
  soldout: 'neutral',
};

export const MISSING_URGENCY_STATUS_VARIANT: Record<MissingUrgency, SemanticStatusVariant> = {
  urgent: 'error',
  anticipate: 'warning',
  plan: 'info',
};

export const MISSING_URGENCY_TONE: Record<MissingUrgency, DataGridV2Tone> = {
  urgent: 'danger',
  anticipate: 'warning',
  plan: 'info',
};

export const MISSION_PURCHASE_ORDER_INDICATOR_VARIANT: Record<MissionPurchaseOrderIndicator, SemanticStatusVariant> = {
  ok: 'success',
  missing: 'error',
  expired: 'error',
  exhausted: 'error',
  notRequired: 'neutral',
};

export const getPurchaseOrderDisplayStatusPalette = (
  theme: Theme,
  status: PurchaseOrderDisplayStatus,
): SemanticStatusPalette => getSemanticStatusPalette(theme, PURCHASE_ORDER_DISPLAY_STATUS_VARIANT[status]);

export const getMissingUrgencyPalette = (theme: Theme, urgency: MissingUrgency): SemanticStatusPalette =>
  getSemanticStatusPalette(theme, MISSING_URGENCY_STATUS_VARIANT[urgency]);

export const getMissionPurchaseOrderIndicatorPalette = (
  theme: Theme,
  indicator: MissionPurchaseOrderIndicator,
): SemanticStatusPalette => getSemanticStatusPalette(theme, MISSION_PURCHASE_ORDER_INDICATOR_VARIANT[indicator]);
